import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HelpTopicKey } from '@core/models/domain/help.domain';
import { HelpPanelComponent, HelpPanelData } from '../help-panel/help-panel.component';

/**
 * The Help button a page carries in its header. It opens that page's help in a dialog, so the
 * reader keeps the page they were asking about behind it.
 */
@Component({
  selector: 'app-help-button',
  templateUrl: './help-button.component.html',
  styleUrls: ['./help-button.component.scss'],
  standalone: false,
})
export class HelpButtonComponent {
  @Input({ required: true }) topic!: HelpTopicKey;
  /** Shown next to the icon. Set to false where the header has no room for a word. */
  @Input() showLabel = true;

  constructor(private dialog: MatDialog) {}

  openHelp(): void {
    this.dialog.open<HelpPanelComponent, HelpPanelData>(HelpPanelComponent, {
      data: { topicKey: this.topic },
      width: '640px',
      maxWidth: '95vw',
      autoFocus: false,
      panelClass: 'help-panel-dialog',
    });
  }
}
